<template>
    <PopoverRight ref="popoverSite" width="500px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增坐席</h1>
            <p class="remark">1、一个分机号下最多绑定10个坐席</p>
            <p class="remark">2、联系电话可输入11位手机号码；或区号+座机号码。（无需间隔符号，例如07318888888）</p>
            <el-form class="form-container" :model="formList" ref="dynamicValidateForm">
                <el-card class="box-card" v-for="(target, key) in formList.domains" :key="key">
                    <i class="el-icon-close" @click.prevent="removeDomain(target)"></i>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">坐席昵称</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                :prop="'domains.' + key + '.staff_name'" 
                                :rules="nickNameRule"
                            >
                                <el-input placeholder="请输入坐席昵称" class="input-control" v-model="target.staff_name"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">联系电话</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item label=""
                                :prop="'domains.' + key + '.staff_phone'" 
                                :rules="seatMobileRule"
                            >
                                <el-input placeholder="请输入联系电话" class="input-control" v-model="target.staff_phone"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-card>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button @click="addDomain" v-if="!isEdit">新增选项</el-button>
                    <el-button type="primary" @click="submitForm('dynamicValidateForm')" v-if="formList.domains.length > 0">提交</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
export default {
    name: 'AddSite',
    components: {
        PopoverRight
    },
    props: {
        callback: Function,
        size: Number
    },
    data () {
        const validateSiteMobile = (rule, value, callback) => {
            if(value === ''){
                 callback(new Error(`坐席电话不能为空`))

            }
            if(!/^\d{10,12}$/.test(value)){
                 callback(new Error(`联系电话为11位手机号或10-12位座机号`))
            }
            if(value.length==10  && !value.match(/0[0-9]{9}/g)  || value.length==12 && !value.match(/0[0-9]{11}/g)){
                callback(new Error(`联系电话为11位手机号或10-12位座机号`))
            }else if(value.length==11  && !value.match(/[0-1]{1}[0-9]{10}/g)){//    /1[3-9]{1}[0-9]{9}/g
              callback(new Error(`联系电话为11位手机号或10-12位座机号`))
            }else{
                 callback()
            }
        }
        return {
            formList: {
                domains: [
                    {
                        staff_name: '',
                        staff_phone: ''
                    }
                ]
            },
            nickNameRule: [
                { required: true, message: '坐席昵称不能为空', trigger: 'blur' },
                { min: 2, max: 15, message: '坐席昵称为2-15个字符之间', trigger: 'blur' },
            ],
            seatMobileRule: [
                { validator: validateSiteMobile, trigger: 'blur' }
            ],
            isEdit: false,
            index: null
        }
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (data, index) {
            if (data) {
                this.formList.domains = [data]
                this.index = index
                this.isEdit = true
            }
            this.$refs.popoverSite && this.$refs.popoverSite.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.$refs.popoverSite && this.$refs.popoverSite.hide()
            this.$refs.dynamicValidateForm && this.$refs.dynamicValidateForm.clearValidate()
            this.resetForm()
        },
        resetForm () {
            this.formList = {
                domains: [
                    { staff_name: '', staff_phone: '' }
                ]
            }
            this.isEdit= false
            this.index= null
        },
        addDomain () {
            if ((10 - this.size) === this.formList.domains.length) {
                this.$message({
                    type: 'error',
                    message: '最多只能绑定10个坐席'
                })
                return null
            }
            this.formList.domains.push({
                staff_name: '',
                staff_phone: '',
                key: Date.now(),
                isAdd: true,
            });
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return null

                // 判断当前是否有重复的数据
                const index = this.formList.domains.findIndex((v, v1) => {
                    const k = this.formList.domains.findIndex((a, a1) => {
                        return a.staff_phone === v.staff_phone && a1 !== v1
                    })
                    return k >= 0
                })
                if (index >= 0) {
                    this.$message({
                        type: 'error',
                        message: '不能添加重复的坐席电话'
                    })
                    return null
                }
                this.callback(this.formList.domains, this.index)
                this.hideMenu()
            })
        },
         removeDomain(item) {
            const index = this.formList.domains.indexOf(item)
            if (index !== -1) {
                this.formList.domains.splice(index, 1)
            }
        }
    }
}
</script>
<style scoped>
.remark{
    font-size: 12px;
    padding-top: 10px;
    color: #999;
}
</style>